import { type PropsWithChildren } from 'react'
import styled from 'styled-components'

import { Layout } from '@loadsmart/miranda-react'

const StyledBox = styled(Layout.Box)`
  cursor: pointer;
  max-width: 270px;
`

type SelectableBoxProps = PropsWithChildren<{
  readonly selected: boolean
  readonly onClick: () => void
}>

export default function SelectableBox({ selected, children, onClick }: SelectableBoxProps) {
  return (
    <StyledBox
      backgroundColor={selected ? 'color-background-tertiary' : 'color-background-primary'}
      borderColor={selected ? 'color-border-input' : 'color-border'}
      borderWidth="border-thin"
      onClick={onClick}
    >
      {children}
    </StyledBox>
  )
}
